
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projeto Gemini',
	'appExit': 'Acesse a página de Boas-Vindas',


	'widgetsListLabel': 'Lista de widgets. Selecione um widget e pressione Enter para incluir.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Atualizar',
	'dirty': 'Não atualizar',
	'conflict': 'Conflito ao salvar a visualização',
	'error': 'Problema ao salvar a visualização',
	'failure': 'Não é possível entrar em contato com o servidor',
	'saveFailed': 'Não é possível salvar a visualização',

	'wa_insync': 'Salvo',
	'wa_conflict': 'Conflito ao salvar a visualização',
	'wa_error': 'Não é possível salvar a visualização',
	'wa_failure': 'Não é possível entrar em contato com o servidor',

	// Menu Labels
	'changeDisplay': 'Alterar exibição',
	'changeToColumnChart': 'Alterar para gráfico de colunas',
	'changeToBubbleChart': 'Alterar para gráfico de bolhas',
	'toggleMoveHandles': 'Alternar identificadores de movimentação',
	'undo': 'Desfazer',
	'redo': 'Refazer',
	'mode': 'Alterar o modo',

	'untitled': 'Sem Título',
	'remove': 'Remover',
	'editTitle': 'Editar o título',
	'edit': 'Editar',
	'done': 'Pronto',

	// Data tray
	'dataTrayHandleOpenLabel': 'Abrir bandeja de dados',
	'dataTrayHandleCloseLabel': 'Fechar bandeja de dados',

	// Dialogs
	'dlg_loading': 'Carregando...',
	'dlg_ok': 'OK',
	'dlg_create': 'Criar',
	'dlg_cancel': 'Cancelar',
	'dlg_close': 'Fechar',
	'dlg_update': 'Atualizar',
	'dlg_renameBoardTitle': 'Renomear este objeto',
	'dlg_renameDatasetTitle': 'Renomear este conjunto de dados',
	'dlg_renameSceneTitle': 'Renomear este cenário',
	'dlg_NameLabel': 'Nome:',
	'dlg_NewNameLabel': 'Novo nome:',
	'dlg_DefaultNameWithDataSet': '%{name} visualização',
	'dlg_ShareTitle': 'Conteúdo compartilhado',
	'dlg_UnshareTitle': 'Remover compartilhamento de conteúdo',
	'dlg_ShareUser': 'ID do Usuário:',
	'dlg_NewColumnLabel': 'Novo nome de cálculo',

	'dlg_new': 'Novo...',
	'dlg_open': 'Abrir...',
	'dlg_makeACopy': 'Fazer uma cópia',
	'dlg_rename': 'Renomear...',
	'dlg_moreToCome': 'Mais ações a caminho...',

	'dlg_use': 'Usar',

	'dlg_RelinkDatasetTitle': 'Substituir o conjunto de dados \'%{datasetName}\' por...',

	'open_error': 'Ocorreu um problema ao abrir a visualização.',

	// Delete Board
	'del_dialogTitle': 'Confirmar Exclusão',
	'del_itemMsg': 'Tem certeza de que deseja excluir \'%{name}\'?',
	'del_itemsMsg': 'Tem certeza de que deseja excluir %{count} itens?',
	'del_deleteErr': 'Não é possível excluir \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'descendente',
	'dlg_custom': 'customizado',
	'dlg_none': 'nenhum',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Procurar',

	'searchHint': 'Procurar todos os seus dados',
	'clearSearchResult': 'Limpar os resultados da procura',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Círculo',
	'shapesHexagon': 'Hexágono',
	'shapesLine': 'Linha',
	'shapesOctagon': 'Octógono',
	'shapesPentagon': 'Pentágono',
	'shapesSquare': 'Quadrado',
	'shapesTriangle': 'Triângulo',
	'shapesDiamond': 'Losango',
	'shapesTitle': 'Propriedades de forma', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Quadrado arredondado',
	'shapesStar': 'Estrela',
	'shapesChevron': 'Divisa',
	'shapesBadge_ribbon': 'Faixa de opções de badge',
	'shapesBadge': 'Distintivo',
	'shapesHeart': 'Coração',
	'shapesExclamation': 'Exclamação',
	'shapesTrendingup': 'Tendência crescente',
	'shapesTrendingdown': 'Tendência decrescente',
	'shapesX': 'i',

	// People shapes
	'shapesPeopleCat': 'Pessoal',
	'shapesFemale': 'TXCDCLASS_ID',
	'shapesHappyface': 'Face feliz',
	'shapesMale': 'Masculino',
	'shapesMan': 'Man',
	'shapesNeutralface': 'Face neutra',
	'shapesSadface': 'Face triste',
	'shapesShakehands': 'Apertar mãos',
	'shapesThumbsdown': 'Desanimado',
	'shapesThumbsup': 'Animado',
	'shapesWoman': 'Mulher',

	// Weather and places
	'shapesPlacesWeatherCat': 'Locais & clima',
	'shapesCity': 'Localidade',
	'shapesCloud': 'Nuvem',
	'shapesEducation': 'Aprendizado',
	'shapesGovernment': 'Governo',
	'shapesHalfcloud': 'Meia nuvem',
	'shapesHouse': 'Residência',
	'shapesMoon': 'Lua',
	'shapesRain': 'Chuva',
	'shapesSunny': 'Ensolarado',

	//Vehicles
	'shapesVehiclesCat': 'Veículos',
	'shapesAirplane': 'Avião',
	'shapesCar': 'Carro',
	'shapesShip': 'Enviar',
	'shapesShoppingcart': 'Carrinho de compras',
	'shapesTrain': 'Treinar',
	'shapesTruck': 'Caminhão',

	//Objects
	'shapesObjectsCat': 'Objetos',
	'shapesBook': 'Manual de instruções',
	'shapesBriefcase': 'Porta-arquivos',
	'shapesCalendar': 'Calendário',
	'shapesCheck': 'Verifique.',
	'shapesClock': 'Relógio',
	'shapesDesktop': 'Computador de mesa',
	'shapesDocument': 'Documento',

	'shapesFood': 'Alimentos',
	'shapesGear': 'Marcha',
	'shapesHealth': 'Condição',

	'shapesIdea': 'Ideia',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Cédula de dinheiro',
	'shapesMoney_coin': 'Moeda de dinheiro',
	'shapesPiggybank': 'Cofre de porquinho',
	'shapesStackofpaper': 'Pilha de papel',
	'shapesStickynote1': 'Nota de Tolerância 1',
	'shapesStickynote2': 'Nota de Tolerância 2',
	'shapesTarget': 'Destino',
	'shapesTool': 'Ferramenta',

	'shapesUmbrella': 'Umbrella',

	'shapesBrain': 'Cérebro',
	'shapesSkull': 'Caveira',
	'shapesEye': 'Olhal',

	// Arrows shapes
	'shapesArrowsCat': 'Setas',
	'shapesRightArrow': 'Seta para direita',
	'shapesLeftArrow': 'Left arrow',
	'shapesDoubleArrow': 'Seta dupla',
	'shapesCurvedArrow': 'Seta curvada',

	// Callouts shapes
	'shapesCalloutsCat': 'Callouts',
	'shapesRectCallout': 'Callout',

	// Images
	'imagesCat': 'Imagens',
	'imageWidgetTitle': 'Widget da imagem',
	'imgUrl': 'URL da imagem',
	'noImgSelected': 'Nenhuma imagem selecionada',
	'enterImgUrl': 'Insira a URL da imagem aqui',
	'imgPasteLink': 'Cole a URL e pressione Inserir para salvar. ',
	'imgResizeToFit': 'Redimensione para ajustar o tamanho da imagem',
	'imgHeight': 'Altura:',
	'imgWidth': 'Largura:',
	'imgTransparency': 'Transparência:',
	'imgMissingUrl': 'A URL da imagem está ausente.',
	'imgUrlValidationError': 'A URL da imagem não é válida.',
	'imgUrlInvalidDomainError': 'A URL da imagem está apontando para um domínio que não foi aprovado por seu administrador. Os domínios aprovados por seu administrador são "%{domains}".',

	// line shape
	'propStrokeWidth': 'Densidade da linha',
	'propStrokeDashArray': 'Estilo da Linha (Line style)',
	'propStrokeSolidline': 'Linha sólida',
	'propStrokeLineCap': 'Valor máximo de linha',
	'propStrokeLineCapButt': 'Topo',
	'propStrokeLineCapRound': 'Circular',
	'propStrokeLineCapSquare': 'Quadrado',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Executar',
	'dataPlayerValueListLabel': 'Valores do reprodutor de dados',
	// Text Widget
	'textWidgetTitle': 'Widget de texto',
	'textStyle': 'Estilos',
	'textStyleDescription': 'Estilos de texto pré-formatados',
	'textTitleStyle': 'Título',
	'textTitleSmallStyle': 'Título pequeno',
	'textSubtitleStyle': 'Subtítulo',
	'textBodyStyle': 'Corpo',
	'textBodySmallStyle': 'Corpo pequeno',
	'textCaptionStyle': 'Texto Explicativo',
	'textQuoteStyle': 'Citar',
	'textQuoteSmallStyle': 'Citação pequena',
	'textResponsiveStyle': 'Dimensionamento automático',
	'textAutoFontSize': 'Automático',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Fio',
	'textFontFamilySubClassThin': 'Fina',
	'textFontFamilySubClassThinItalic': 'Thin Itálico',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Itálico Extra Claro',
	'textFontFamilySubClassLight': 'Claro',
	'textFontFamilySubClassLightItalic': 'Itálico Claro',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Itálico Regular',
	'textFontFamilySubClassItalic': 'Itálico',
	'textFontFamilySubClassMedium': 'Média',
	'textFontFamilySubClassMediumItalic': 'Itálico Médio',
	'textFontFamilySubClassHeavy': 'Pesado',
	'textFontFamilySubClassHeavyItalic': 'Pesado Itálico',
	'textFontFamilySubClassDemiBold': 'Demi Negrito',
	'textFontFamilySubClassDemiBoldItalic': 'Negrito Médio Itálico',
	'textFontFamilySubClassBold': 'Negrito',
	'textFontFamilySubClassBoldItalic': 'Negrito Itálico',
	'textFontFamilySubClassExtraBold': 'Negrito Extra',
	'textFontFamilySubClassExtraBoldItalic': 'Extra Negrito Itálico',
	'textFontFamilySubClassBlack': 'Preto',
	'textFontFamilySubClassBlackItalic': 'Preto Itálico',
	'textFontFamilySubClassStencil': 'Estêncil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Fonte de tamanho automático',
	'responsiveCoachmarkContents': 'O tamanho da fonte é redimensionado automaticamente para ajustar-se quando este tipo de texto é redimensionado. É possível configurar o tamanho da fonte nas propriedades de texto.',

	'propText': 'Detalhes de texto', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Propriedades do Texto', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Tamanho de fonte',
	'textFontFamily': 'Família de fontes',
	'textFontWeight': 'Peso da fonte', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': 'Link de imagem',
	'propMissingURL': 'Inserir URL',
	'propImgTop': 'Propriedades da Imagem', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Propriedades gerais', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Geral', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Geral', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Cor de preenchimento', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Cor do texto', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Cor da borda',
	'propMaintainAxisScales': 'Manter escala do eixo',
	'propShowItemLabel': 'Mostrar o rótulo do item',
	'propHideLegend': 'Ocultar a legenda',
	'propColorPalette': 'Paleta',
	'propLegendPosition': 'Ranqueamento de legenda',
	'propHideAxisTitleLabels': 'Ocultar títulos do eixo',
	'propLineColor': 'Cor da linha',
	'propBubbleColor': 'Cor da bolha',
	'propInterpolation': 'Linhas suaves',
	'propElementColor': 'Cor do elemento de visualização',
	'propSymbolShape': 'Forma do símbolo',
	'propHeatScalePalette': 'Cor da ordem',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Cores mais escuras representam valores menores.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Cores mais escuras representam valores maiores.',
	'propImageDetails': 'Detalhes da Imagem', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Detalhes da página da web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Detalhes de mídia', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Insira a URL e pressione Enter.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Posição e estilo',
	'propPositionLabel': 'Posição', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'i', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'E', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': 'Tamanho', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': 'Largura',
	'propResizeHeight': 'Altura',
	'propRotateLabel': 'Girar',
	'propRotateAngle': 'Ângulo', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Quantidade de ícones',
	'propScaleDescription': 'Selecione a quantidade de ícones',
	'propScaleFew': 'Baixa',
	'propScaleDefault': 'Padrão',
	'propScaleMany': 'Alta',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Este valor deve ser numérico',

	'mediaAriaLabel': 'entrada de url',
	'dropdownAriaLabel' : 'Dropdown',
	'ariaGroupLabel': 'Categoria de lista suspensa: %{cateoryLabel} item: %{itemLabel}. Pressione a tecla DOWN para expandir. Pressione as teclas UP e DOWN para navegar ou Pressione a tecla ESCAPE para reduzir.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Última atualização: %{timeInterval} atrás',
	'widgetTimer': 'Cronômetro do widget',

	// Theme colors
	'transparent': 'Nenhuma cor',
	'white': 'Branco',
	'lightGrey': 'Cinza claro',
	'grey': 'Cinza',
	'darkGrey': 'Cinza escuro',
	'black': 'Preto',
	'lightBlue': 'Azul claro',
	'blue': 'Azul',
	'darkBlue': 'Azul escuro',
	'yellow': 'Amarelo',
	'orange': 'Laranja',
	'lime': 'Verde limão',
	'green': 'Verde',
	'peach': 'Pêssego',
	'red': 'Vermelho',
	'violet': 'Violeta',
	'aqua': 'Azul piscina',
	'purple': 'Roxo',
	'plum': 'ameixa',
	'gray10': 'Cinza 10',
	'gray20': 'Cinza 20',
	'gray30': 'Cinza 30',
	'gray50': 'Cinza 50',
	'gray60': 'Cinza 60',
	'gray70': 'Cinza 70',
	'gray80': 'Cinza 80',
	'gray90': 'Cinza 90',
	'gray100': 'Cinza 100',
	'blue50': 'Azul 50',
	'blue60': 'Azul 60',
	'blue70': 'Azul 70',
	'green40': 'Verde 40',
	'green50': 'Verde 50',
	'red50': 'Vermelho 50',
	'red60': 'Vermelho 60',


	//Theme Palette Label
	'paletteLabel': 'Paleta %{number} da IBM',
	'heatPaletteLabel': 'Paleta de aquecimento %{number} da IBM',
	'conditionalPaletteLabel': 'Patela condicional %{number} da IBM',
	'carbonPaletteXLight': 'Carbon X Light',
	'carbonPaletteXDark': 'Carbon X Dark',
	'carbonPalettePurple': 'Roxo',
	'carbonPaletteTeal': 'Azul esverdeado',
	'carbonPaletteCyan': 'Ciano',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Roxo, Azul esverdeado',
	'carbonPaletteCyanMagenta': 'Ciano, Magenta',
	'carbonPaletteGreenRed': 'Verde, Vermelho',
	'carbonPaletteGreenYellowRed': 'Verde, Amarelo, Vermelho',
	'carbonPalettePurpleTealConvergent': 'Roxo, Azul esverdeado, Convergente',
	'carbonPaletteCyanMagentaConvergent': 'Ciano, Magenta, Convergente',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Paleta luz IBM',
	'userPaletteColor_defaultTheme': 'Paleta padrão da IBM',
	'userPaletteColor_darkTheme': 'Paleta escura IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Cor de plano de fundo',
	'propLayoutPositioning': 'O posicionamento de Layout',
	'propLayoutRelative': 'Relativo',
	'propLayoutAbsolute': 'Absoluto',
	'propLayoutPositioningCoachmarkTitle': 'Selecione um estilo de layout',
	'propLayoutPositioningCoachmarkContent': 'Em um layout relativo, o tamanho e a posição de widgets se ajustam para caber na tela. Os widgets em um layout absoluto aparecem exatamente como você os dimensionou e posicionou na visualização, independentemente do tamanho da tela.',
	'gridText': 'Mostrar grade',
	'snapText': 'Ajustar na grade',
	'snapObjectsText': 'Objetos para Ajustar',
	'fitPageText': 'Ajustar página',
	'gridLabel': 'Grade',
	'heightUnit': 'H',
	'widthUnit': 'W',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Tamanho da Página',
	'propPageSizePresetAriaLabel': 'Pré-configuração do tamanho da página',
	'propPageSizePreset': 'Pré-configurado',
	'propPageSizePresetCustom': 'Personalização',
	'propPageSizePreset16x9': 'Tela 9 de 16:',
	'propPageSizePreset4x3': 'Tela 3 de 4:',
	'propPageSizePresetInfographic': 'Infográfico',
	'propPageSizeWidth': 'Largura',
	'propPageSizeHeight': 'Altura',
	'propPageSizeWidthAriaLabel': 'Largura do tamanho',
	'propPageSizeHeightAriaLabel': 'Tamanho da altura da página',
	'propPageSizeAdjustedMessage': 'O tamanho da página foi aumentado porque sua entrada estava abaixo do mínimo ou não se ajustaria ao seu painel.',
	'propTabShow': 'Mostrar guias',
	'propShowTabsInPreview': 'Mostrar guias na visualização',
	'multilingualDashboardsLabel': 'Idiomas',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Padrão',
	'multilingualDashboardsAddLinkText': 'Incluir outro idioma',
	'multilingualDashboardsSelect': 'Selecionar',
	'multilingualDashboardsButtonLabel': 'Incluir',
	'multilingualDashboardTranslationMode': 'Você está agora no modo de tradução (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Pronto',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} traduções restantes',
	'multilingualDashboardRemainingString': '1 tradução restante',
	'multilingualDashboardsSetDefault': 'Configure o idioma padrão',
	'multilingualDashboardIconMore': 'Mais ações para o idioma %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Área Traduzível',
	'multilingualDeleteTitle': 'Excluir Idioma',
	'multilingualDeleteLanguageWarning': 'Tem certeza de que deseja excluir o idioma \'%{language}\'?',
	'multilingualSelectLanguage': 'Selecione um idioma',
	'confirmLayoutStyleUpgradeTitle': 'Aplicar a todas as guias',
	'confirmLayoutStyleUpgrade': 'Aplicar esse estilo de layout em todas as guias em seu painel?',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Excluir',
	'tabDeleteDialogTitle': 'Excluir esta guia?',
	'tabDeleteDialogMessage': 'Todo o conteúdo nessa guia também seráexcluído.',

	// Vis widget
	'propVisTypeReturn': 'Tipos de visualização',
	'propVisDetails': 'Detalhes',

	// Alignment picker
	'propAlignPickTop': 'Alinhamento superior',
	'propAlignPickRight': 'Alinhamento direito',
	'propAlignPickBottom': 'Alinhamento inferior',
	'propAlignPickLeft': 'Alinhamento esquerdo',
	'propAlignPickCenter': 'Alinhamento central',
	'propAlignPicker': 'Alinhamento',

	// Toolbar picker
	'propToolbarPickBold': 'Negrito',
	'propToolbarPickUnderline': 'Sublinhado',
	'propToolbarPickItalic': 'Itálico',
	'propToolbarPickJustifyLeft': 'Alinhamento esquerdo',
	'propToolbarPickJustifyCenter': 'Alinhamento central',
	'propToolbarPickJustifyRight': 'Alinhamento direito',
	'propToolbarPickJustify': 'Justificar',

	'propList': 'Lista',
	'propOrderedList': 'Lista ordenada',
	'propUnorderedList': 'Lista não ordenada',

	// Symbol shapes
	'propCircle': 'Círculo',
	'propTriangle': 'Triângulo',
	'propSquare': 'Quadrado',
	'propRect': 'Retângulo',
	'propStar': 'Estrela',
	'propCross': 'Cruzado',
	'propPlus': 'Mais',
	'propPoly': 'Polígono',


	// True and false selection
	'propTrue': 'Verdadeiro',
	'propFalse': 'Falso',

	// Position selection
	'propLeft': 'Esquerda',
	'propRight': 'Direita',
	'propTop': 'Parte superior',
	'propBottom': 'Parte inferior',

	// Interpolation options
	'propSmooth': 'Suave',
	'propStraight': 'Linear',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lista', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Mover para a esquerda', // screen reader
	'srWidgetMoveUp': 'Mover para cima', // screen reader
	'srWidgetMoveRight': 'Mover para a direita', // screen reader
	'srWidgetMoveDown': 'Mover para baixo', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Aumentar o tamanho proporcionalmente', // screen reader
	'srWidgetResizeSmaller': 'Diminuir o tamanho proporcionalmente', // screen reader
	'srWidgetResizeBiggerV': 'Aumentar o tamanho verticalmente', // screen reader
	'srWidgetResizeSmallerV': 'Diminuir o tamanho verticalmente', // screen reader
	'srWidgetResizeBiggerH': 'Aumentar o tamanho horizontalmente', // screen reader
	'srWidgetResizeSmallerH': 'Diminuir o tamanho horizontalmente', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Girar no sentido horário', // screen reader
	'srWidgetRotateCCW': 'Girar no sentido anti-horário', // screen reader

	// Recommended types
	'visChange': 'Alterar visualização',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualização',
	'chartLabel': '%{chartName} gráfico',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pressione F12 para navegar no widget',
	'f10KeyDescription': 'Pressione F10 para ativar a visualização de foco do widget',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} com o valor %{value}',

	'shapeColorLabel': 'Cor da forma',
	'showLegendLabel': 'Mostrar legenda',

	//Webpage
	'webpageWidgetTitle': 'Widget da página da web',
	'webpagePasteLink': 'Cole a URL e pressione Enter para salvar.',
	'propWebpageLink': 'URL da página da web',
	'propWebpageTitle': 'Título da página da web',
	'propWebpageTitleDescription': 'Título da página da web',
	'webpageUrl': 'URL da página da web',
	'noWebpageSelected': 'Nenhuma página da web selecionada',
	'enterWebpageUrl': 'Insira a URL da página da web aqui',
	'propWebpageTop': 'Propriedades da página da web', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'A URL da página da web está ausente.',
	'webpageUrlValidationError': 'A URL da página da web não é válida.',
	'webpageHttpValidationError': 'A página da web deve ser acessada usando um link HTTPS.',
	'webpageInvalidDomainError': 'A URL da página da web está apontando para um domínio que não foi aprovado por seu administrador. Os domínios aprovados por seu administrador são "%{domains}".',

	//VizState
	'vzErrorLoading': 'Não é possível carregar a visualização',
	'vzErrorLoadingMissingData': 'Não é possível carregar a visualização, dados de contexto ausentes',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Widget de mídia',
	'mediaPasteLink': 'Cole a URL e pressione Enter para salvar.',
	'mediaUrl': 'URL da mídia',
	'noMediaSelected': 'Nenhuma mídia selecionada',
	'enterMediaUrl': 'Insira a URL da mídia aqui',
	'videoHeight': 'Altura:',
	'videoWidth': 'Largura:',
	'propMediaLink': 'Link de mídia',
	'propMediaTitle': 'Título da mídia',
	'propMediaTitleDescription': 'Título da mídia',
	'propMediaTop': 'Propriedades de mídia', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'A URL do link de mídia está ausente.',
	'mediaUrlValidationError': 'A URL do arquivo de mídia não é válida.',
	'mediaUnknownValidationError': 'Esse tipo de mídia não é suportado. ',
	'mediaHttpValidationError': 'O arquivo de mídia deve ser acessado usando um link HTTPS.',
	'mediaInvalidDomainError': 'A URL do arquivo de mídia está apontando para um domínio que não foi aprovado por seu administrador. Os domínios aprovados por seu administrador são "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Propriedades', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Conjunto de dados',
	'dataViewsLabel': 'Visualização',
	'columnQuality': 'Qualidade de dados',
	'columnProperties': 'Propriedades de dados',

	'dataQuality': 'Qualidade de dados',
	'dataQualityRowCount': 'Número de linhas',
	'dataQualityDistribution': 'Distribuição',
	'dataRowLabel': 'Dados',

	// Modelling UI
	'typeColumn': 'Tipo',
	'modellingColumnType': 'Tipo',
	'modellingColumnAggregation': 'Agregação',
	'modellingColumnUsage': 'Uso',
	'modellingColumnSort': 'Classificação',
	'modellingColumnFormat': 'Formato',
	'modellingColumnCategory': 'Categoria',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Carregando...',

	'modellingProcessing': 'Processando...',
	'modellingImport': 'Importar',
	'modellingReimport': 'Reimportação',
	'modellingDatasourceTitle': 'Origem de dados',
	'modellingImportStartedTitle': 'Importação iniciada',
	'modellingImportStartedText': 'A importação de seus dados pode levar algum tempo.\n\n(É possível criar uma visualização enquanto os dados são importados.) ',
	'importDatasourceTitle': 'Conexões',
	'dropHere': 'Arraste aqui para criar uma nova origem de dados...',
	'browseButton': 'Procurar',
	'errorNoData': 'Não existem dados a serem processados.',
	'errorNoFile': 'Não existe arquivo para upload.',
	'errorUploadFailed': 'Não é possível fazer upload.',
	'uploadSucceessful': 'Upload com sucesso',
	'del_datasourceTitle': 'Excluir conjunto de dados',
	'del_datasourceMsg': 'Tem certeza de que deseja excluir \'%{name}\'?',
	'modellingFileUpdate': 'Atualizar',
	'modellingFileUpdateTitle': 'Atualizar conjunto de dados',
	'modellingFileUpdateDescription': 'Deseja atualizar \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Atualizando \'%{name}\'',
	'modellingUpdateStartedTitle': 'Atualização de importação iniciada',
	'modellingUpdateStartedText': 'A atualização de seus dados pode levar algum tempo.\n\n(É possível criar uma visualização enquanto os dados são atualizados.)',
	'modellingErrorImportUploadNoFile': 'Nenhum arquivo para fazer upload.',
	'modellingErrorImportUploadFailed': 'Não é possível fazer upload.',
	'modellingErrorImportUploadInvalidType': 'O tipo de arquivo não é válido.',
	'modellingErrorImportUploadTableFailed': 'Não é possível obter tabelas.',
	'modellingIntentResultsTitle': 'Selecione o conjunto de dados proposto a ser usado.',
	'modellingColumnViewRelationships': 'Visualizar tabelas relacionadas',
	'modellingTableRelatedTables': 'Tabelas relacionadas a \'%{name}\'',
	'modellingTable': '%{name} - Tabela',
	'modellingColumnIncludedInDataSet': 'Incluído',
	'modellingDataSet': 'Conjunto de dados',
	'modellingViewInDataSet': 'Visualização em conjunto de dados',
	'modellingViewRelatedTables': 'Visualização relacionada',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nenhuma tabela relacionada localizada',

	'modellingValidatingDataset': 'Validando...',
	'datasetFinishedRefreshing': 'O conjunto de dados %{datasetName} foi atualizado.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Resolver caminho da junção:',
	'modellingJoinColumns': 'Defina um caminho de junção para a tabela: %{name}',
	'modellingJoinToTable': 'Realize a junção à tabela: %{name}',

	// Data Quality
	'excluded': 'Excluído',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtrar',
	'modellingColumnSortNone': 'Limpar a classificação',
	'modellingColumnSortAsc': 'Classificar Ascendente',
	'modellingColumnSortDesc': 'Classificar Decrescente',
	'modellingColumnRemove': 'Remover esta coluna',

	// Import File Browser
	'dropboxPageTitle': 'Nova conexão do Dropbox',
	'sizeColumn': 'Tamanho',

	//Modelling Column Property Values
	'dataType_string': 'Sequência',
	'dataType_date': 'Data',
	'dataType_integer': 'Número Inteiro',
	'dataType_double': 'Duplo',
	'dataType_float': 'Flutuante',
	'dataType_boolean': 'Booleano',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Contar',
	'defaultAggregation_countdistinct': 'Contagem distinta',
	'defaultAggregation_max': 'Máximo',
	'defaultAggregation_min': 'Mínimo',
	'defaultAggregation_avg': 'Média',
	'defaultAggregation_sum': 'Soma',
	'defaultAggregation_auto': 'Automático (%{aggregationType})',

	'type_fact': 'Fato',
	'type_attribute': 'Atributo',

	'defaultSort_none': 'Não classificar',
	'defaultSort_asc': 'Classificar Ascendente',
	'defaultSort_desc': 'Classificar Decrescente',

	'category_none': 'Nenhum',
	'category_location': 'Local',
	'category_monetary': 'Monetary',
	'category_time': 'Horário',

	// Root menu
	'rootMenuTitle': 'Menu principal',

	'errorMessageTitle': 'Erro',
	'errorMessageDetails': 'Detalhes: ',
	'errorMessageTitleAssetAlreadyExists': 'O ativo já existe',

	'defaultTabTitle': 'Guia %{index}',
	'tabAddBtnTitle': 'Incluir uma nova tabela',

	'unsupportedConditionalFormattingEncountered': 'A formatação condicional não é mais aplicada a algumas colunas.',


	// Homepage View
	'nameColumn': 'Nome',
	'creatorColumn': 'Criado por',
	'creationDateColumn': 'Data criada',
	'versionColumn': 'Versão',
	'modifiedColumn': 'Última Modificação',

	'filterBy': 'Filtrar itens',
	'allFilter': 'Todos os itens',
	'createdByMeFilter': 'Criado por mim',
	'sharedWithMeFilter': 'Compartilhado por mim',
	'favoritesFilter': 'Meus favoritos',
	'recentsFilter': 'Incluído recentemente',
	'sortBy': 'Classificar por',

	// Sort Menu
	'sortModified': 'Modificado',
	'sortUpdated': 'Atualizado',
	'sortName': 'Nome',

	'viewAs': 'Visualizar como',
	'thumbnailsView': 'Visualizar como miniaturas',
	'listView': 'Visualizar como uma lista',
	'createMenu': 'Criar',
	'newAppItem': 'Painel',
	'newDataSet': 'Conjunto de dados',

	'menuSelectionState_a11y': '"%{item}" seletor configurado como "%{selectedItem}"',

	'unableToShareItem': 'Não é possível compartilhar o item "%{item}".',
	'toastFetchingContent': 'Obtendo mais conteúdo...',
	'unableToGetData': 'Não é possível obter conteúdo.',
	'unableToFavorite': 'Não é possível alterar o status Favorito.',
	'hpErrorMissingRequiredOptions': 'Opções de inicialização requeridas ausentes',
	'unableToOpenBoard': 'Não é possível abrir "%{name}".',
	'unableToDuplicateBoard': 'Não é possível duplicar "%{name}".',
	'unableToCreateBoard': 'Não é possível criar "%{name}".',
	'unableToCreateBoardNameConflict': 'Um ativo com o mesmo nome já existe.',

	// DataSet Detail View
	'status': 'Status',
	'numberOfRows': 'Linhas',
	'importWarnings': 'Avisos',
	'lineNumbers': 'Linhas',
	'excerptFromSource': 'Extrato',
	'reason': 'Motivo',
	'numberOfRowsDropped': 'linhas soltas',
	'oneRowDropped': '1 linha foi descartada',

	// Type Menu
	'typeMenuLabel': 'Tipo',
	'dashboardsLabel': 'Painéis',
	'datasetsLabel': 'Conjuntos de dados',
	'storiesLabel': 'Histórias',
	'allLabel': 'Todos os tipos',

	// Board Page View App Bar
	'datasets': 'Conjuntos de dados',
	'settings': 'Propriedades',
	'add': 'Incluir',
	'widgets': 'Widgets',
	'dashboardProperties': 'Propriedades do painel',
	'searchPanel' : 'Procurar',
	'pins': 'Coleção',
	'pinsOld': 'Minhas fixações',
	'pinsDateFilterHeading' : 'Data fixada',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} item fixado |||| %{smart_count} itens fixados',
	'pinSearch': 'Procurar',
	'pinSearchOld': 'Procurar alfinetes',
	'pinListView': 'Visualização de lista',
	'pinIconView': 'Visualização do ícone',
	'pinRemove': 'Remover',
	'pinCreate': 'Criar',
	'pinDeleteError': 'Não é possível excluir um ou mais ativos da coleção. Tente novamente mais tarde.',
	'pinDeleteErrorOld': 'Não podemos excluir um ou mais alfinetes. Tente novamente mais tarde.',
	'pinRetrieveError': 'Não é possível recuperar um ou mais alfinetes. Tente novamente mais tarde.',
	'NoPinsCollected': 'Nenhuma visualização fixada',
	'pinDeletedToast': 'Pino foi removido',
	'pinAddedToast': 'Pino foi incluído com sucesso em Meus Pinos',
	'pinningToast': 'Processando pino ...',
	'pinDateFilter': 'Filtro de data',
	'pinDateFilterAll': 'Todas',
	'pinDateFilterToday': 'Hoje',
	'pinDateFilterYesterday': 'Ontem',
	'pinDateFilterPastWeek': 'Semana passada',
	'pinDateFilterPastMonth': 'Mês passado',
	'pinDateFilterEarlier': 'Anterior',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Editar título',
	'toolbarActionSort': 'Classificação',
	'toolbarActionSortAscending': 'Classificar Ascendente',
	'toolbarActionSortDescending': 'Classificar Decrescente',
	'toolbarActionSortAuto': 'Automático (%{sortOrder})',
	'toolbarActionFormat': 'Formatar dados',
	'toolbarActionFormatAbbreviation': 'Abbreviate',
	'toolbarActionFormatNone': 'Automático',
	'toolbarActionFilter': 'Filtrar',
	'toolbarActionTopBottom': 'Parte superior ou parte inferior',
	'toolbarActionAddShape': 'Incluir formato',
	'toolbarActionRmvShape': 'Remover formato',
	'toolbarActionToggleShapeDrop': 'Forma do infográfico',
	'toolbarActionToggleShapeDropTitle': 'Criar um infográfico',
	'toolbarActionToggleShapeDropText': 'Arraste uma forma até este campo para criar um infográfico.',
	'toolbarActionAggregationType': 'Resumo',
	'toolbarDeleteActionText': 'Remover coluna',
	'toolbarActionFilterLocalKeepSelected': 'Manter',
	'toolbarActionFilterLocalExcludeSelected': 'Excluir',
	'toolbarActionFilterAllKeepSelected': 'Filtrar',
	'toolbarActionSimpleCalculation': 'Cálculo simples',
	'toolbarActionDrillBack': 'Voltar',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionNavigate': 'Navegar',
	'toolbarActionCreateFilterGroup': 'Criar nova conexão',
	'toolbarActionDisconnectFilterGroup': 'Quebrar todos os links',
	'toolbarActionLinkFilterGroup': 'Incluir em uma conexão existente',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Incluir',
	'sidebarMultiselect': 'Alternar diversas seleções',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} selecionado',

	'multiselectWithTotalMsg': '%{count} de %{total}',
	'sidebarGoBack': 'Voltar',

	//DataSet pane
	'errorLoadingDataSets': 'Não podemos carregar este conjunto de dados',
	'errorLoadingDataSetMetaData': 'Não podemos carregar este conjunto de dados',
	'dataSetPaneLastUpdated': 'Última atualização: %{date}',
	'dataSetPaneDateUnknown': 'Desconhecido',
	'sourcePaneLabel': 'Origens selecionadas',
	'addSourceLabel': 'Incluir uma origem',
	'find_label': 'Localizar',
	'navigationPathsLabel': 'Caminhos de navegação',

	//widgetlist
	'errorLoadingWidgetList': 'Não podemos carregar os objetos.',
	'errorLoadingThemeFile': 'Não podemos carregar a definição de tema',
	'errorLoadingLayoutFile': 'Não podemos carregar a visualização.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Não podemos carregar as definições de visualizações disponíveis',

	'dwErrorLoadingVisualizationNotFound': 'Não podemos carregar o objeto, visto que está faltando uma definição de visualização',
	'dwErrorLoadingVisualizationListNotFound': 'Não podemos carregar a visualização.',
	'dwErrorRunningQuery': 'Não é possível recuperar os dados do conjunto de dados %{datasetName}.',
	'dwErrorGeoData': 'Estamos tendo problemas para exibir os dados geográficos em um mapa. Escolha outro tipo de visualização. ',
	'dwPromptSignonCancelWarning': 'Os dados para esta visualização estão indisponíveis. Forneças as credenciais corretas.',
	'dwErrorMissingDataset': 'Não é possível carregar a visualização porque o conjunto de dados \'%{datasetName}\' associado a ela não está disponível.',
	'dwErrorRenderingVisualization': 'Não podemos carregar esta visualização.',
	'dwErrorVisualizationTooSmall': 'A visualização é muito pequena para exibir os dados que ela contém. Torne a visualização maior ou limite os dados que ela contém.',
	'aria_label_datatable': 'Tabela de dados',
	'aria_key_navi_datatable_desc': 'Use as teclas de seta para navegar para cada célula. Pressione as teclas Control e Home para mover para a primeira linha e teclas Control e End para mover para a última linha.',
	'geomapUnrecognizedLocations': 'Locais não reconhecidos:',
	'geomapAmbiguousLocations': 'Regiões ambíguas:',

	// custom widget
	'customWidget': 'Widget customizado',
	'customWidgetsTitle': 'Widgets customizados',
	'noCustomWidgets': 'Nenhum widget customizado',

	// Action names
	'toggleContextBar': 'Alternar a barra de contexto',
	'delete': 'Excluir',
	'share': 'Compartilhar',
	'unshare': 'Remover Compartilhamento',
	'rename': 'Renomear',
	'close': 'Fechar',
	'duplicate': 'Duplicado',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Tentar Novamente',

	'changeTemplate': 'Mudar modelo',

	// Aggregation Types
	'sum': 'Soma',
	'count': 'Contar',
	'countdistinct': 'Contagem distinta',
	'avg': 'Média',
	'min': 'Mínimo',
	'max': 'Máximo',
	'custom': 'Personalização',
	'calculated': 'Calculado',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% de mudança',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Critérios de visualização...',
	'QuickAddResultsHeader': 'Visualizações de dados',
	'NoQuickAddResults': 'Nada correspondeu ao seu intento. Criar um novo conjunto de dados?',
	'NoQuickAddResultsRetry': 'Não podemos localizar as correspondências. Tente novamente com termos diferentes.',
	'templateWidgetTitle': 'Modelo',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(em branco)',

	'nullValueContent': '(sem valor)',
	'nullValueText': 'Nulo',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filtro de texto - %{columnName}',

	'textFilterSelectTab': 'Selecionar',

	'textFilterConditionTab': 'Configurar uma condição',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Nenhum item está disponível.',

	'textFilterEquals': 'Igual a',
	'textFilterContains': 'Contém',
	'textFilterBeginsWith': 'Inicia com',
	'textFilterEndsWith': 'Termina com',
	'textFilterDoesNotEqual': 'Não é igual a',
	'textFilterDoesNotContain': 'Não contém',
	'textFilterDoesNotBeginWith': 'Não começa com',
	'textFilterDoesNotEndWith': 'Não termina com',
	'textFilterSampleText': 'Por exemplo: A',

	'textFilterAndButton': 'E',
	'textFilterOrButton': 'Ou',

	'dateFilterMessage': 'Selecione um intervalo de datas',
	'dateRangeControlRegionLabel': 'Filtro de intervalo de data - %{columnName}',
	'dateFilterRangeOption': 'Opção de intervalo',
	'dateFilterDateLabel': 'Data',
	'dateFilterBlank': '(em branco)',
	'dateFilterBefore': 'Antes',
	'dateFilterAfter': 'Depois',
	'dateFilterBetween': 'Entre',
	'dateFilterSampleText': 'AAAA-MM-DD',
	'dateTitle': 'Data',
	'dateIncludeBlankLabel': 'Incluir data em branco',

	'timeTitle': 'Horário',
	'timeFilterMessage': 'Selecione um intervalo de horários',
	'dateTimeFilterMessage': 'Selecione um intervalo de datas e horas',

	'topbottomNumberOfResultsLabel': 'Número de Resultados',
	'topbottomPercentLabel': 'Porcentagem',
	'topbottomNumberOfResultsLimit': 'Entre %{lower} e %{higher}',
	'topbottomSelectOption': 'Opção de parte superior ou parte inferior',
	'topbottomOptionLabel': 'Mostrar',
	'searchByLabel': 'Por',
	'searchNoMatches': 'Nenhuma correspondência encontrada',
	'topbottomRankColumnLabel': 'Inclua uma classificação para a tabela',
	'topbottomNone': 'Nenhum',
	'topCount': 'Contagem superior',
	'topPercent': '% primeiros',
	'bottomCount': 'Contagem inferior',
	'bottomPercent': '% últimos',
	'topbottomSearchColumn': 'Localize uma coluna',
	'searchColumnAriaLabel': 'Localize uma coluna. Digite o nome da coluna a ser procurada, em seguida, use a seta para baixo para localizar a coluna em uma lista',
	'rankColumnLabel': 'Classificação (%{columnLabel})',
	'topbottomClearLabel': 'Limpar',

	'rangeFilterControlRegionLabel': 'Filtro de intervalo - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Controle da régua de controle, use as setas da direita e da esquerda para mover os manipuladores da régua de controle',
	'sliderHandleLabel': 'Manipulador da régua de controle',
	'a11ySliderHandleLabel': 'Alça de régua de controle %{sliderValue}',
	'sliderInputLabel': 'valor',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Alguns itens do conjunto de dados usados nesta visualização estão indisponíveis.',
	'datasetItemUnavailable': 'Este item do conjunto de dados está indisponível',

	//Authoring topBottom
	'topOperator': 'Parte superior',
	'bottomOperator': 'Parte inferior',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} por %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Somente este objeto',
	'deleteTopBottom': 'Excluir contagem superior ou inferior',
	'editTopBottom': 'Editar contagem superior ou inferior',
	'deleteDrillState': 'Excluir estado de drill atual',
	'ariaDeleteDrillStateLabel': 'Pressione a tecla ENTER para editar a contagem superior ou inferior.',
	'drillUpStateTitle': 'Drill Up',
	'drillDownStateTitle': 'Drill Down',
	'ariaEditTopBottomLabel': 'Pressione a tecla ENTER para editar a contagem superior ou inferior.',
	'ariaDeleteTopBottomLabel': 'Pressione a tecla DELETE para excluir a contagem superior ou inferior.',

	// Authoring filtering
	'dimFilterIn': 'Inclui: %{in}',
	'dimFilterNotIn': 'Exclui: %{out}',
	'measureFilterBetween': 'Entre %{lowerBound} e %{upperBound}',
	'measureFilterNotBetween': 'Não está entre %{lowerBound} e %{upperBound}',
	'gtFilter': 'Após %{lowerBound}',
	'ltFilter': 'Antes de %{upperBound}',
	'notGtFilter': 'Não está após %{lowerBound}',
	'notLtFilter': 'Não está antes de %{upperBound}',
	'localFilterTitle': 'Somente este objeto',
	'globalFilterTitle': 'Todos os objetos',
	'deleteFilter': 'Excluir Filtro',
	'editFilter': 'Editar Filtro',
	'ariaEditFilterLabel': 'Pressione a tecla ENTER para editar o filtro.',
	'ariaDeleteFilterLabel': 'Pressione a tecla DELETE para excluir o filtro.',

	// Prompts
	'ariaEditPrompt': 'Pressione a tecla ENTER para mudar o valor do prompt',

	'moreDataIndicator': 'Seus dados foram recortados em %{threshold} itens. Aplique um filtro para mostrar menos.',

	// data point filtering
	'dataPointFilterTitle': 'Pontos de dados',
	'dataPointFilterIncludeSummary': '%{valueCount} pontos de dados foram incluídos',
	'dataPointFilterExcludeSummary': '%{valueCount} pontos de dados foram excluídos',

	// DB2 connection page
	'db2Database': 'Banco de dados DB2 (%{jdbcConnection})',
	'db2Title': 'Conectar-se ao IBM DB2',

	// Database
	'databaseConnectionMessage': 'Forneça os detalhes de conexão com o seu banco de dados:',
	'connectionString': 'Sequência de conexão de banco de dados',
	'databaseCredentials': 'Credenciais: ',
	'databaseUserName': 'Nome de usuário',
	'databasePassword': 'Senha',
	'databaseConnect': 'Conectar',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Insira um termo de procura:',
	'twitterKeyword': 'Palavra-Chave',
	'twitterSearch': 'Procurar',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Caixa suspensa',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Não é possível criar a visualização: %{error}\nOperação com falha: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtros do widget',
	'missingColumn': 'Ausente: %{columnLabel}',
	'missingFiltering': 'Filtros ausentes nos IDs da coluna a seguir:',
	'heatByLabel': 'Utilização por',
	'evColumns': 'Colunas',
	'evLocalFilters': 'Filtros locais',
	'evExpand': 'Expandir',
	'evFilterTooltip': 'Filtrar',
	'evAdd': 'Incluir uma coluna',

	// Navigation View
	'navigationBack': 'Voltar',

	// Pinning
	'contentPinFail': 'Não podemos coletar o conteúdo. Tente novamente mais tarde.',
	'contentPinFailOld': 'Não podemos fixar o conteúdo. Tente novamente mais tarde.',

	// Layouts
	'dropZoneLabel': 'Soltar aqui para maximizar',

	//Share
	'shareDefaultPageTitle': 'Página %{index}',

	'nextPage': 'Página Seguinte',
	'previousPage': 'Página Anterior',

	'assetAssembly': 'vista',

	'toolbar_save': 'Salvar',
	'brgr_saveAs': 'Salvar como',
	'brgr_refresh': 'Atualizar',

	// Save
	'saving': 'Salvando...',
	'save_success': 'Sua visualização foi salva.',
	'save_failure': 'Desculpe. Sua visualização não pôde ser salva. Tente novamente mais tarde.',
	'dashboard_save_success': 'Seu painel foi salvo.',

	'geminiLeave': 'Você está prestes a deixar o IBM Watson Analytics.',

	'warning': 'Aviso',
	'missingDataSetData': 'Os dados para este conjunto de dados não estão disponíveis. Atualize o conjunto de dados ou entre em contato com o administrador para acessar a origem.',

	// Calculations
	'error_calculation_in_use': 'O cálculo selecionado está em uso e não pode ser excluído.',

	'resize': 'Redimensionar na',
	'rotate': 'Girar',
	'moveHandle': 'Mover widget',
	'expandHandle': 'Expandir',
	'panHandle': 'Panoramizar',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navegue para',

	// Slide out titles
	'shapeSlideoutTitle': 'Formas',
	'textSlideoutTitle': 'Texto',
	'mediaSlideoutTitle': 'Mídia',
	'visualizationSlideoutTitle': 'Visualizações',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'O JSON fornecido é inválido. Consulte o log de erro para obter mais informações.',

	// Widget type labels
	'shape_label': 'Forma',
	'image_label': 'Imagem',
	'data_label': 'Gráfico',
	'media_label': 'Mídia',
	'text_label': 'Texto',
	'embedMedia_label': 'Mídia',
	'youtube_label': 'Vídeo do YouTube',
	'webpage_label': 'Página da Web',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Forma',
	'noExtraText_shape_numbered': 'Forma (%{number})',
	'few_shape': 'Grupo de %{count} formas',
	'many_shape': 'Grupo de %{count} formas',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} imagem',
	'one_image_numbered': '%{text} imagem (%{number})',
	'noExtraText_image': 'Imagem',
	'noExtraText_image_numbered': 'Imagem (%{number})',
	'few_image': 'Grupo de %{count} imagens',
	'many_image': 'Grupo de %{count} imagens',
	'noExtraText_text': 'Caixa de texto vazia',
	'noExtraText_text_numbered': 'Caixa de texto vazia (%{number})',
	'few_text': 'Grupo de %{count} caixas de texto',
	'many_text': 'Grupo de %{count} caixas de texto',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Visualizador de cubo',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} pelas tabelas cruzadas %{row_level1} e %{column_level1}',
	'crosstab_opt_mapping_numbered': '%{values} pelas tabelas cruzadas %{row_level1} e %{column_level1} (%{number})',
	'crosstab_has_mapping': '%{values} pela tabela cruzada %{row_level1}',
	'crosstab_has_mapping_numbered': '%{values} pela tabela cruzada %{row_level1} (%{number})',
	'crosstab_no_mapping': 'Crosstab vazia',
	'crosstab_no_mapping_numbered': 'Tabela cruzada vazia (%{number})',
	'crosstab_named': '%{name} tabela cruzada',
	'crosstab_named_numbered': '%{name} tabela cruzada (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tabela',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tabela (%{number})',
	'JQGrid_no_mapping': 'Tabela Vazia',
	'JQGrid_no_mapping_numbered': 'Tabela vazia (%{number})',
	'JQGrid_named': '%{name} tabela',
	'JQGrid_named_numbered': '%{name} tabela (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} hierarquia',
	'hierarchy_has_mapping_numbered': '%{level1} hierarquia (%{number})',
	'hierarchy_no_mapping': 'Hierarquia vazia',
	'hierarchy_no_mapping_numbered': 'Hierarquia vazia (%{number})',
	'hierarchy_named': '%{name} hierarquia',
	'hierarchy_named_numbered': '%{name} hierarquia (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} mapa',
	'map_has_mapping_numbered': '%{categories} mapa (%{number})',
	'map_no_mapping': 'Mapa vazio',
	'map_no_mapping_numbered': 'Mapa vazio (%{number})',
	'map_named': '%{name} mapa',
	'map_named_numbered': '%{name} mapa (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} valor de resumo',
	'summary_has_mapping_numbered': '%{actual} valor de resumo (%{number})',
	'summary_no_mapping': 'Valor de sumarização vazio',
	'summary_no_mapping_numbered': 'Valor de resumo vazio (%{number})',
	'summary_named': '%{name} valor de resumo',
	'summary_named_numbered': '%{name} valor de resumo (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} pelo KPI %{sparkline.time}',
	'kpi_opt_mapping_numbered': '%{actual} pelo KPI %{sparkline.time} (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'KPI vazio',
	'kpi_no_mapping_numbered': 'KPI vazio (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infográfico',
	'infographicSummary_has_mapping_numbered': '%{actual} infográfico (%{number})',
	'infographicSummary_no_mapping': 'Infográfico vazio',
	'infographicSummary_no_mapping_numbered': 'Infográfico vazio (%{number})',
	'infographicSummary_named': '%{name} infográfico',
	'infographicSummary_named_numbered': '%{name} infográfico (%{number})',
	'noExtraText_youtube': 'Vídeo do YouTube',
	'noExtraText_youtube_numbered': 'Vídeo do Youtube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} vídeo do Youtube',
	'one_youtube_numbered': '%{text} vídeo do Youtube (%{number})',
	'few_youtube': 'Grupo de %{count} vídeos do Youtube ',
	'many_youtube': 'Grupo de %{count} vídeos do Youtube',
	'noExtraText_embedMedia': 'Link de mídia',
	'noExtraText_embedMedia_numbered': 'Link de mídia (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} link de mídia',
	'one_embedMedia_numbered': '%{text} link de mídia (%{number})',
	'few_embedMedia': 'Grupo de %{count} links de mídia',
	'many_embedMedia': 'Grupo de %{count} links de mídia',
	'noExtraText_media': 'Mídia',
	'noExtraText_media_numbered': 'Mídia (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} mídia',
	'one_media_numbered': '%{text} mídia (%{number})',
	'few_media': 'Grupo de %{count} mídias',
	'many_media': 'Grupo de %{count} mídias',
	'noExtraText_webpage': 'Página da web',
	'noExtraText_webpage_numbered': 'Página da web (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} página da web',
	'one_webpage_numbered': '%{text} página da web (%{number})',
	'few_webpage': 'Grupo de %{count} páginas da web',
	'many_webpage': 'Grupo de %{count} páginas da web',
	'one_unknown': 'Um objeto',
	'one_unknown_numbered': 'Um objeto (%{number})',
	'few_unknown': 'Grupo de %{count} objetos',
	'many_unknown': 'Grupo de %{count} objetos',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Avançar',
	'previous': 'Anterior',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'O grupo de navegação atual é %{navigation_group_name}',

	//Page Context
	'filterBlank': '(em branco)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Valores de filtro não podem ser carregados',
	'editTimelineHighlight': 'Editar destaque',

	'filterDockChevronLeft': 'Percorra os dados',
	'filterDockChevronRight': 'Percorra os dados',
	'expand': 'Expandir',
	'collapse': 'Reduzir',

	//Reset Dashboard
	'dashboardResetTitle': 'Reconfigurar Painel',
	'dashboardResetMessage': 'Tem certeza de que deseja reconfigurar todas as mudanças aplicadas a esse painel?',
	'dashboardResetToast': 'Seu painel foi reconfigurado.',

	//Generate PDF
	'buildingPDF': 'Criando o PDF...',
	'exportPDF': 'Exportar para PDF',
	'pageSize': 'Tamanho da Página',
	'orientation': 'Orientação',
	'filtersPresentPDF': 'Filtros aplicados às visualizações na página anterior:',
	'errorPDF': 'Não foi possível gerar o PDF. Atualize e tente novamente.',
	'printPDFInfo': 'Visualizar documentação',
	'pdfWidget': 'Widget',
	'includeFilters': 'Mostrar detalhes do filtro',
	'portrait': 'Retrato',
	'landscape': 'Paisagem',
	'letter': 'Carta',
	'legal': 'Jurídico',
	'a4':'A4',
	'tabloid':'Jornal',

	'toastUpgradeDone': 'O upgrade de seu painel foi realizado. Salve agora para manter o desempenho adequado.',

	'ariaFullScreenMessage': 'Pressione Escape para sair da tela cheia',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} gráfico de bolhas de hierarquia empacotado',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} gráfico de bolhas de hierarquia empacotado (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Esvazie as malas hierarquia gráfico de bolhas',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Gráfico de bolhas de hierarquia empacotado vazio (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} gráfico de bolhas de hierarquia empacotado',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} gráfico de bolhas de hierarquia empacotado (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} pelo gráfico Marimekko %{values}',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} pelo gráfico Marimekko %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Gráfico Marimekko vazio',
	'LIVE_marimekko_no_mapping_numbered': 'Gráfico Marimekko vazio (%{number})',
	'LIVE_marimekko_named': '%{name} gráfico Marimekko',
	'LIVE_marimekko_numbered': '%{name} gráfico Marimekko (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} gráfico de explosão solar',
	'LIVE_sunburst_has_mapping_numbered': '%{values} gráfico de explosão solar (%{number})',
	'LIVE_sunburst_no_mapping': 'Gráfico vazio de explosão solar',
	'LIVE_sunburst_no_mapping_numbered': 'Gráfico de explosão solar vazio (%{number})',
	'LIVE_sunburst_named': '%{name} gráfico de explosão solar',
	'LIVE_sunburst_named_numbered': '%{name} gráfico de explosão solar (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} gráfico de análise de driver',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} gráfico de análise de driver (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Gráfico de análise do driver vazio',
	'LIVE_decision_analysis_no_mapping_numbered': 'Gráfico de análise de driver vazio (%{number})',
	'LIVE_decision_analysis_named': '%{name} gráfico de análise de driver',
	'LIVE_decision_analysis_named_numbered': '%{name} gráfico de análise de driver (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} pelos gráficos de colunas e linhas %{columnValue} e %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} pelos gráficos de colunas e linhas %{columnValue} e %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': 'Gráficos de colunas e linhas %{columnValue} e %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': '%{categories} pelos gráficos de colunas e linhas %{columnValue} e %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Gráfico de linhas e colunas vazio',
	'LIVE_line_column_no_mapping_numbered': 'Gráfico de colunas e linhas vazio (%{number})',
	'LIVE_line_column_named': '%{name} gráfico de colunas e linhas',
	'LIVE_line_column_named_numbered' : '%{name} gráfico de colunas e linhas (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} pelos gráficos de bolhas %{y} e %{size}',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} pelos gráficos de bolhas %{y} e %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Gráfico de bolhas vazio',
	'LIVE_bubble_chart_no_mapping_numbered': 'Gráfico de bolhas vazio (%{number})',
	'LIVE_bubble_chart_named': '%{name} gráfico de bolhas',
	'LIVE_bubble_chart_named_numbered': '%{name} gráfico de bolhas (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} gráfico marcador',
	'LIVE_bullet_has_mapping_numbered': '%{actual} gráfico marcador (%{number})',
	'LIVE_bullet_no_mapping': 'Gráfico de marcadores vazio',
	'LIVE_bullet_no_mapping_numbered': 'Gráfico marcador vazio (%{number})',
	'LIVE_bullet_named': '%{name} gráfico marcador',
	'LIVE_bullet_named_numbered': '%{name} gráfico marcador (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Os dados deste painel são fornecidos por',
	'showFooterToggleButtonText': 'Mostrar rodapé',
	'showFooterSectionText': 'Rodapé'
});
